module.exports = __webpack_public_path__ + "img/QBurger.dcf4b1fe.svg";